import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => {
  // Drawer styling
  const notificationsPanelHeight = '500px';
  const notificationsPanelWidth = '400px';

  return {
    paper: {
      width: notificationsPanelWidth,
      maxHeight: notificationsPanelHeight,
      zIndex: theme.zIndex.modal,
      position: 'absolute',
      left: '5%',
      bottom: '5%',
      overflow: 'scroll',
    },
    listSubHdr: {
      color: theme.evPalette.aloe[700],
      backgroundColor: theme.evPalette.salt[100],
    },
  };
});
